import AulaEditorWithPlugins from './AulaEditorWithPlugins';
import withFileBlocksValidation from './withFileBlocksValidation';
import withAnalytics from './withAnalytics';
import withCustomStyles from './withCustomStyles';
import withErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import withFileScanFromRedux from './withFileScanFromRedux';

const AulaEditorWithAnalytics = withErrorBoundary(
  withCustomStyles(
    withFileScanFromRedux(
      withAnalytics(withFileBlocksValidation(AulaEditorWithPlugins))
    )
  ),
  { ignore: true }
);

export default AulaEditorWithAnalytics;
